<template>
    <div class="bang-rigth">
        <span class="gongsi">
            公司信息
        </span>
        <div class="borearss">
            <img src="../assets/logo.jpg">
        </div>
        <div style="text-align: center;">
            <span class="mokisa huanghang">
                {{$store.state.orgName}}
            </span>
        </div>
        <div class="xian"></div>
        <div class="moaksa">
            <span class="siaosaf">
                企业认证
            </span>
            <div class="siaosaf-q">
                <el-button class="anniu" type="primary" size="mini" icon="el-icon-check">已认证
                </el-button>
            </div>
        </div>
        <div class="ellipsis" style="margin-top: 20px;">
            <span class="siaosaf">
                经营范围
            </span>
            <span class="mokisa">
                <span v-for="(item,index) in $store.state.productList" :key="index">{{item.tagName}}</span>
            </span>
        </div>
        <!-- <div class="moiuysa">
            + 立即关注
        </div> -->
    </div>
</template>
<script>
    export default {
        name: "ShopCompany",
        data() {
            return {}
        },
        methods: {}
    };
</script>

<style scoped>
    .bang-rigth {
        width: 260px;
        background: #FFFFFF;
        border: 1px solid #ABC0EC;
        border-radius: 10px;
        margin: 0 auto;
        padding: 20px;
        text-align: left;
    }

    .gongsi {
        font-size: 14px;
        color: #333333;
        line-height: 28px;
    }

    .borearss {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin: 0 auto;
        margin-top: 10px;
        margin-bottom: 30px;
    }

    .borearss>img {
        width: 48px;
        height: 48px;
        background: #5F93FF;
        border-radius: 50%;
    }

    .mokisa {
        margin-left: 10px;
        font-size: 14px;
    }

    .moaksa {
        display: flex;
    }

    .xian {
        border-bottom: 1px solid #CCCCCC;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .siaosaf {
        font-size: 14px;
        color: #999999;
        line-height: 28px;
    }

    .anniu {
        background: #FEB960;
        border: none;
    }

    .siaosaf-q {
        margin-left: 22px;
        background: #FEB960;
        border-radius: 4px;
        font-size: 14px;
        color: #FFFFFF;
    }

    .mokisa {
        margin-left: 10px;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/ShopCompany.vue